import { BillingitemMoveRequestV26 } from 'src/app/models-v26/billingitem-v26';
import { ContractTreeNodeV26 } from 'src/app/models-v26/contract-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { MoveBillingitemsDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/move-billingitems-wizard/activation-step/movebillingitems-due-date-info';
import { MoveBillingitemsInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/move-billingitems-wizard/init-step/init-step';

export interface State {
  initStep: MoveBillingitemsInitStepV26;
  dueDatesStep: MoveBillingitemsDueDatesV26;
  contractStep: ContractTreeNodeV26[];
  request: BillingitemMoveRequestV26;
  response: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  initStep: null,
  dueDatesStep: { activationDate: null },
  contractStep: null,
  request: null,
  response: null,
  errorMessage: null,
};
